import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { GeneralSmartParkError } from 'src/registry/types/axios';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/monitoring/gateway/:gatewayId/lock/`;

type MutationFnType = typeof mutationFn;

type DTO = {
    parkingId: string;
    gatewayId: string;
};

const mutationFn = ({ gatewayId, parkingId }: DTO): Promise<void> => {
    return axios.post(formatResourcePath(RESOURCE, { gatewayId, parkingId }));
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralSmartParkError>) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useLockGateway };
